// extracted by mini-css-extract-plugin
export default {"listCards":"ItemsList_listCards__+VH6c"};